import React from 'react';
import history from '../../history';
import { LoadingScreen } from '../../containers/LoadingScreen/LoadingScreen';
import URI from 'urijs';

export const OIDCLoading = () => {
  const currentURL = window.location.search;
  const parsedURL = URI.parseQuery(currentURL);

  const { error, error_description, state } = parsedURL;
  const accessTokenObj = JSON.parse(localStorage.getItem('oidc.default'));
  const accessToken =
    accessTokenObj && accessTokenObj.tokens
      ? accessTokenObj.tokens.accessToken
      : null;
  const idToken =
    accessTokenObj && accessTokenObj.tokens
      ? accessTokenObj.tokens.idToken
      : null;

  if (state && accessToken && idToken) {
    history.replace(
      `/with-gp2token?accessToken=${accessToken}&idToken=${idToken}`
    );
  }

  if (error === 'access_denied' && error_description.includes('AADB2C90091')) {
    console.warn('User cancelled the login process');
    history.replace('/');
  }
  return <LoadingScreen parseOidcTokens />;
};



// WEBPACK FOOTER //
// ./src/containers/OIDC/OIDCLoading.jsx